export function blockDndKey(e) {
    if (e.key === " " || e.key === "Enter") e.stopPropagation()
}
